import SystemPortalView from './containers/SystemPortalView.js';

export default SystemPortalView;
